import Vue from 'vue'
import interRelatedService from '@/library/interRelated'
import constants from './constants'
// import store from '@/store'

var clone = function (obj) {
  return JSON.parse(JSON.stringify(obj))
}

const mutations = {
  getConfig (state) {
    // console.log('BetSlip getCongig')
    var data = window.ctsautoconf.BETSLIP
    for (var i in data) {
      Vue.set(state, i, data[i])
    }
  },
  setBetSlipUpdadeStatus (state, val) {
    Vue.set(state, 'doBetSlipUpdade', val)
  },
  setInRefferal (state, val) {
    Vue.set(state, 'inRefferal', val)
  },
  setActiveBetSlip (state, id) {
    Vue.set(state, 'activeBetSlip', id)
  },
  setActiveBetSlipHistoryTab (state, tab) {
    let tab2 = state.historyTabs.indexOf(tab) >= 0 ? tab : ''
    Vue.set(state, 'historyTab', tab2)
  },
  clearSingleBetSlip (state, idSingl) {
    // console.log('clearSingleBetSlip')
    idSingl = idSingl || state.singleBetSlip.selection.idfoselection
    Vue.set(state.singleBetSlip, 'selection', {})
    // Vue.delete(state.betslipSelectionsIds, idSingl)
    Vue.delete(state.betTypeStakes.PerSelection, idSingl)
    Vue.delete(state.betTypeStakes.REGULAR.PerSelection, idSingl)
    Vue.delete(state.returns.PerSelection, idSingl)
  },

  setCloseFromParent (state, val) {
    Vue.set(state, 'closeFromParent', val)
  },

  setWinning (state, obj) {
  },

  dismissErrorFromSelection (state, id) {
    var v = state.dismissErrorFromSelection
    v += 1
    Vue.set(state, 'dismissErrorFromSelectionId', id)
    Vue.set(state, 'dismissErrorFromSelection', v)
  },

  setActiveTeaser (state, arr) {
    // state.teasers.active[arr[0]] = arr[1]
    state.teasers.activeByGroup[arr[0]] = arr[1]
  },

  clearAllowedBetTypesAndReturns4Teasers (state) {
    state.allowedBetTypesAndReturns.TEASER = {
      NFL: clone(constants.initialABTnR),
      BASKETBALL: clone(constants.initialABTnR),
      MIXED: clone(constants.initialABTnR)
    }
  },

  setMultiSinglesStake (state, val) {
    state.multiSinglesStake = val
  },

  setTab (state, id) {
    Vue.set(state, 'tab', id)
  },

  setConfirmBetPlacement (state, val) {
    state.confirmBetPlacement = val
  },

  setShowAcceptingChangesInfo (state, val) {
    state.showAcceptingChangesInfo = val
  },

  setCurrentBetSlipState (state, id) {
    state.currentBetSlipState = id
  },

  setBetSlipStatus (state, status) {
    state.betSlipStatus = status
  },

  setBetPlacementResult (state, obj) {
    state.betPlacementResult = obj
  },

  setAttemptedBetSlip (state, obj) {
    state.attemptedBetSlip = obj
  },

  clearAttemptedBetSlip (state) {
    state.attemptedBetSlip = {}
  },

  setBetPlacementResultStatus (state, status) {
    state.betPlacementResult.result.Status = status
  },

  resetAllowedBetTypesAndReturns (state) {
    Vue.set(state, 'gettingABTnR', true)
    Vue.set(state, 'allowedBetTypesAndReturns', clone(constants.initialABTnRperTab))
    Vue.set(state, 'allowedBetTypesAndReturnsSelectionsStr', '')
    Vue.set(state.allowedBetTypesAndReturnsSelectionsCall, 'REGULAR', '')
    Vue.set(state.allowedBetTypesAndReturnsSelectionsCall, 'RR', '')
    Vue.set(state.allowedBetTypesAndReturnsSelectionsCall, 'TEASER', {})
  },
  resetAllowedBetTypesAndReturnsStr (state) {
    Vue.set(state, 'allowedBetTypesAndReturnsSelectionsStr', '')
  },

  resetABTnR4Teaser (state, sport) {
    // console.log('resetABTnR4Teaser')
    Vue.set(state.allowedBetTypesAndReturns.TEASER, sport, clone(constants.initialABTnR))
  },

  clearStakesAndReturns (state) {
    // console.log('Mutation clearStakesAndReturns')
    Vue.set(state, 'betTypeStakes', clone(constants.initialBetTypeStakes))
    Vue.set(state, 'returns', clone(constants.initialReturns))
  },

  clearBetSlip (state) {
    // console.log('Mutation clearBetSlip')
    Vue.set(state, 'betslipSelectionsIds', {})
    Vue.set(state, 'betslipSelections', [])
    Vue.set(state, 'betslipSelectionIds', [])
    Vue.set(state, 'idfomarkets', {})
    Vue.set(state, 'idfoevents', {})
    Vue.set(state, 'betTypeStakes', clone(constants.initialBetTypeStakes))
    Vue.set(state, 'returns', clone(constants.initialReturns))
    Vue.set(state.teasers, 'T', clone(constants.initialTeasers))
    Vue.set(state.optedIn, 'RR', {})
    Vue.set(state.optedIn, 'TEASER', {})
    Vue.set(state.teasers.active, 'NFL', 'T1')
    Vue.set(state.teasers.active, 'BASKETBALL', 'T1')
    Vue.set(state.teasers.active, 'MIXED', 'T1')
    Vue.set(state.teasers.activeByGroup, '0', 'T1')
    Vue.set(state.teasers.activeByGroup, '1', 'T1')
    Vue.set(state.teasers.activeByGroup, '2', 'T1')
    Vue.set(state.teasers.activeByGroup, '3', 'T1')
    Vue.set(state.teasers.activeByGroup, '4', 'T1')
    Vue.set(state.teasers.activeByGroup, '5', 'T1')
    Vue.set(state.teasers.activeByGroup, '6', 'T1')
    Vue.set(state.teasers.activeByGroup, '7', 'T1')
    Vue.set(state.teasers.activeByGroup, 'MIXED', 'T1')
    Vue.set(state.teasers, 'teaserGroups', {})
  },

  killHlite (state) {
    // console.log('killHlite')
    var v = state.clearMarkings
    v += 1
    Vue.set(state, 'clearMarkings', v)
    // context.state.clearMarkings = true
  },

  clearMarkings (state) {
    Vue.set(state, 'clearMarkings', 0)
  },

  handicapChangedInc (state) {
    // console.log('handicapChangedInc')
    var v = state.handicapChanged
    v += 1
    Vue.set(state, 'handicapChanged', v)
    // context.state.clearMarkings = true
  },

  removeSelection (state, selection) {
    // console.log('removeSelection')
    // console.log('typeof selection: ' + typeof selection)
    const id = typeof selection === 'object' ? parseFloat(selection.idfoselection) : selection
    Vue.delete(state.markets, id)
    Vue.delete(state.idfomarkets, id)
    Vue.delete(state.idfoevents, id)
    Vue.delete(state.betslipSelectionsIds, id)
    Vue.delete(state.betTypeStakes.REGULAR.PerSelection, id)
    Vue.delete(state.returns.REGULAR.PerSelection, id)
    Vue.delete(state.optedIn.RR, id)
    Vue.delete(state.optedIn.TEASER, id)
    for (var t in state.teasers.T) {
      Vue.delete(state.teasers.T[t], id)
    }

    var index = state.betslipSelectionIds.findIndex(function (s) {
      return s === id
    })
    if (index > -1) {
      if (typeof selection === 'object') {
        selection.isSelected = false
      }
      state.betslipSelections.splice(index, 1)
      state.betslipSelectionIds.splice(index, 1)
    }
    //
    for (var i in state.betSlipChanges) {
      if (Array.isArray(state.betSlipChanges[i])) {
        index = state.betSlipChanges[i].indexOf(id)
        if (index > -1) {
          state.betSlipChanges[i].splice(index, 1)
        }
      }
    }
    // selections = state.betslipSelections.slice()
    var selections = state.betslipSelections
    state.interRelated = interRelatedService.checkInterRelated(selections, state.markets)
    // context.state.betSlipChanges.interRelated = interRelated
    //
  },
  addSelection (state, selectionToAdd) {
    var selection = clone(selectionToAdd)
    // console.log('addSelection')
    // console.log(selection)
    const id = parseFloat(selection.idfoselection)
    Vue.set(state.optedIn.RR, id, true)
    // Vue.set(state.optedIn.TEASER, id, state.teaserSports.indexOf(selection.idfosporttype) > -1)
    state.betslipSelections.push(selection)
    state.betslipSelectionIds.push(id)
    Vue.set(state.betslipSelectionsIds, id, true)
  },

  doTeaserUpdate (state) {
    // console.log('killHlite')
    var v = state.teasers.doUpdate
    v += 1
    Vue.set(state.teasers, 'doUpdate', v)
  },

  setAddingMiltipleSelections (state, val) {
    Vue.set(state.addingMiltipleSelections, 'inProgress', val)
  },

  setUnitStakeMin (state, val) {
    Vue.set(state, 'unitStakeMin', val)
    Vue.set(state.stakeLimits.min, 'PerSelection', val)
    // Vue.set(state.stakeLimits.min, 'PerBetType', val)
  },
  setMultiStakeMinUnit (state, val) {
    Vue.set(state.stakeLimits.min, 'PerBetType', val)
  },
  setUnitStakeMax (state, val) {
    Vue.set(state, 'unitStakeMax', val)
    Vue.set(state.stakeLimits.max, 'PerSelection', val)
    Vue.set(state.stakeLimits.max, 'PerBetType', val)
  },
  setMaxPotentialSlipPayout (state, val) {
    Vue.set(state, 'maxTakeOut', val)
  },
  setSlipTotalStakeMax (state, val) {
    Vue.set(state, 'slipTotalStakeMax', val)
  },
  setSlipTotalStakeMin (state, val) {
    Vue.set(state, 'slipTotalStakeMin', val)
  },
  setSlipTotalStakeMaxInPlay (state, val) {
    Vue.set(state, 'slipTotalStakeMaxInPlay', val)
  },
  isFOPreferredInSingles (state, val) {
    // console.log('isFOPreferredInSingles: ' + val)
    window.ctsautoconf = window.ctsautoconf || {}
    if (window.ctsautoconf.BETSLIP) {
      window.ctsautoconf.BETSLIP.isFOPreferredInSingles = val
    }
    Vue.set(state, 'isFOPreferredInSingles', val)
  },
  isFPPreferredInMultiples (state, val) {
    // console.log('isFPPreferredInMultiples: ' + val)
    window.ctsautoconf = window.ctsautoconf || {}
    if (window.ctsautoconf.BETSLIP) {
      window.ctsautoconf.BETSLIP.isFPPreferredInMultiples = val
    }
    Vue.set(state, 'isFPPreferredInMultiples', val)
  },
  setAutoDismissBetSlip (state, id) {
    // console.log('setAutoDismissBetSlip to ' + id)
    clearTimeout(state.timeouts.autoDismissBetSlip)
    Vue.set(state, 'autoDismissBetSlip', id)
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/sports/betslip/mutations.js